// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-quinn-residences -> quinn-residences-websites -> crescent-valley
// Generated: 2026-10-29T18:35:32.848Z
// Counts: 0 design, 25 content, 50 slot group, 0 collection binding, 6 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose the layout that fits your day </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>A simple breakdown of the fees, services, and optional costs associated with living at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Know your costs before you move in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "engrain-sitemap.height": {
    "overrideType": "VALUE",
    "customValue": "1000",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>Compare layouts, check availability, and find the space that fits how home needs to work.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "nextstep.title": {
    "overrideType": "VALUE",
    "customValue": "<p>See townhome living in person</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourquestions.when_a": {
    "overrideType": "VALUE",
    "customValue": "<p>The scheduler shows the times you can book.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "tourscheduler.widget.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Inside, your townhome comes with granite countertops, stainless steel appliances, in-unit laundry, smart-home technology and a garage. Outside, the clubhouse, pool, pickleball court, dog park and lawn care make downtime easy. <a href=\"/amenities\">See every amenity</a>.</p>",
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Pool days, pickleball and room to spread out</p>",
    "mappedField": null
  },
  "amenityhighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>From laps in the pool to a pickleball match before dinner, Crescent Valley's shared spaces are made for everyday use, with a clubhouse lounge, covered patio, and fenced dog park just a short walk from your front door. Take a closer look in the <a href=\"/gallery\">gallery</a>.</p>",
    "mappedField": null
  },
  "feetable.concierge_note": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Includes filter changes twice a year, exterior pest control, 24-hour maintenance response for emergencies, and positive credit reporting.</p>",
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>New three- and four-bedroom townhomes in Gainesville</p>",
    "mappedField": null
  },
  "interactivemapcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Find your open townhome, street by street.</p>",
    "mappedField": null
  },
  "lifestylehighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At Crescent Valley, the shared spaces fit right into an ordinary week: laps in the pool after work, a pickleball game on Saturday morning, and evening laps around the pet park. Everything is a short walk from your townhome door. See the full list on our <a href=\"/amenities\">amenities</a> page.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>I-985 is right outside the neighborhood, so dinner on the Historic Downtown Gainesville Square, a walk on the Rock Creek Greenway or a day on Lake Lanier are all a short drive away. <a href=\"/neighborhood\">Explore the neighborhood</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Just off I-985, minutes from Lake Lanier</p>",
    "mappedField": null
  },
  "petpolicy.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Cats and dogs settle right in at Crescent Valley, where a fenced on-site dog park with turf, benches, and waste stations sits steps from home and select townhomes offer private fenced backyards. For longer walks, the Rock Creek Greenway is a short drive away in Gainesville.</p>",
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room to roam for every pet</p>",
    "mappedField": null
  },
  "touroptions.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Walk through the Vandermeer, Valehaven, and Vanderbilt in <a href=\"/virtual-tours\">3D</a>, then see a townhome in person on a <a href=\"/schedule-a-tour\">self-guided tour</a> or with our on-site leasing team.</p>",
    "mappedField": null
  },
  "virtualtourembed.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Take a 3D walk through all three Crescent Valley townhome layouts: the three-bedroom Vandermeer, the four-bedroom Valehaven, and the 2,108-square-foot, four-bedroom Vanderbilt. Choose a tour to start, then compare details on our <a href=\"/floor-plans\">floor plans</a>.</p>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactdetails.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanshero.link_fees": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/easy-fee-guide"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "floorplanshero.link_pets": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/pet-policy"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "whyquinn.pillar_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Easy access to great schools, shopping, dining, and everyday essentials."
      }
    }
  },
  "whyquinn.pillar_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Spacious layouts that blend functionality, comfort, and modern style."
      }
    }
  },
  "whyquinn.pillar_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Community-Focused Amenities"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Shared spaces designed to bring neighbors together and create lasting memories."
      }
    }
  },
  "whyquinn.pillar_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Dedicated support and personalized service for a hassle-free rental experience."
      }
    }
  },
  "whyquinn.pillar_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Energy-efficient homes built to reduce environmental impact and help lower your utility costs."
      }
    }
  },
  "amenitieslist.amenity_photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Courtyard"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-45bf-7352-8889-2e8a59f3bad1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fenced private backyards behind a row of Crescent Valley townhomes"
      }
    }
  },
  "amenitieslist.amenity_photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Garage"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-4281-76c1-b5c3-7d478efa64c0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Clean attached townhome garage with an automatic door opener"
      }
    }
  },
  "amenitieslist.amenity_photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Lawn Maintenance"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-e49a-72ea-81cd-3c3ea757001b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Colorful townhomes with neatly kept lawns and landscaping"
      }
    }
  },
  "amenitieslist.amenity_photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Smart-Home Technology"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019faa35-6843-73de-9e93-4ef157d24042.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Wall-mounted smart thermostat and light switches in a townhome"
      }
    }
  },
  "amenitieslist.amenity_photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Pool"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-559f-76de-bef4-d31708604139.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community pool with sun loungers and a wooden pergola"
      }
    }
  },
  "amenitieslist.amenity_photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Playground"
      }
    }
  },
  "amenitieslist.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-4fe0-7728-a227-242ab6dd0c70.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Crescent Valley's pool with lounge chairs and landscaping in front of the clubhouse"
      }
    }
  },
  "amenitygroups.community_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-c45f-74cb-89ed-bf74640df58c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Crescent Valley resort-style pool with lounge chairs and a shaded cabana"
      }
    }
  },
  "amenitygroups.home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-8f65-702d-990d-0388a0525717.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Townhome kitchen with light blue cabinets, granite countertops, a double-sink island, and stainless steel appliances"
      }
    }
  },
  "amenityhighlights.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-559f-76de-bef4-d31708604139.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Pool deck with sun loungers beneath a wooden pergola"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Pool"
      }
    }
  },
  "amenityhighlights.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-a248-7446-b9af-538b8a627a2a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse lounge with a coffee bar, high-top tables, and seating"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse"
      }
    }
  },
  "amenityhighlights.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-6b90-726e-a68d-84c6fc415472.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor pickleball court with blue surface, fencing, and landscaping"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Pickleball Court"
      }
    }
  },
  "amenityhighlights.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-e0ba-728e-9164-32167f8042ca.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor lounge with sofas, chairs, and a stone accent wall"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor Lounge"
      }
    }
  },
  "amenityhighlights.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-d503-741a-8f2a-1aa39a0487ac.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Covered patio with lounge seating and dining tables"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Covered Patio"
      }
    }
  },
  "amenityhighlights.card_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-8d8b-761e-8565-d865be01cd82.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Dog park agility equipment on green turf beside the townhomes"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Dog Park"
      }
    }
  },
  "floorplanshero.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-8f65-702d-990d-0388a0525717.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Townhome kitchen with light blue cabinets, granite island with double sink, and stainless steel appliances"
      }
    }
  },
  "floorplanshero.photo_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-45bf-7352-8889-2e8a59f3bad1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Townhomes with private black-fenced backyards and green lawn"
      }
    }
  },
  "floorplanshero.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-dce4-733a-922e-0a2d4d27841b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Row of colorful Crescent Valley townhomes with manicured lawns under a blue sky"
      }
    }
  },
  "floorplanshero.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-c45f-74cb-89ed-bf74640df58c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community swimming pool with lounge chairs and a shaded cabana"
      }
    }
  },
  "floorplanshero.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-b2ed-76e3-9828-c5dc6274ad83.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept living area flowing into a kitchen with a large island and dining table"
      }
    }
  },
  "floorplanshero.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-aa6d-703c-8916-0974dee7acd5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Furnished townhome living room with a sofa, armchair, and coffee table"
      }
    }
  },
  "floorplanshero.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-a248-7446-b9af-538b8a627a2a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse lounge with a coffee bar, seating, and high-top tables"
      }
    }
  },
  "floorplanshero.photo_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-6b90-726e-a68d-84c6fc415472.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor pickleball and tennis courts surrounded by trees and landscaping"
      }
    }
  },
  "floorplanshero.photo_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-e0ba-728e-9164-32167f8042ca.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor lounge with sofas, ambient lighting, and a brick accent wall"
      }
    }
  },
  "floorplanshero.photo_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-e287-7229-a6e8-1f1662c9fc64.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a king-size bed, dresser with mirror, and ceiling fan"
      }
    }
  },
  "lifestylehighlights.highlight_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Poolside downtime"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Cool off at the community pool, then wind down on your own private patio or balcony once the sun sets."
      }
    }
  },
  "lifestylehighlights.highlight_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Meet the neighbors"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Neighbors run into each other at the pickleball court, the courtyard, the playground, and the dog park."
      }
    }
  },
  "lifestylehighlights.highlight_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Room to focus"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "When you need a change of scenery from the home office, the clubhouse is just a short walk away."
      }
    }
  },
  "neighborhoodcallout.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-cad6-71f6-9b4c-66bcae9f22b0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Walking trail and covered bridge at Wilshire Trails park in Gainesville"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Wilshire Trails"
      }
    }
  },
  "petpolicy.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-97b8-76af-8859-97ca2ddd7300.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fenced dog park with green turf and benches in front of a row of townhomes"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "On-site dog park"
      }
    }
  },
  "propertyoverview.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-dce4-733a-922e-0a2d4d27841b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Row of colorful Crescent Valley townhomes with green lawns under a blue sky"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Townhome exteriors"
      }
    }
  },
  "propertyoverview.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-b2ed-76e3-9828-c5dc6274ad83.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A modern kitchen and living room with a large island and a dining table."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept living"
      }
    }
  },
  "propertyoverview.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-c45f-74cb-89ed-bf74640df58c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Swimming pool with lounge chairs and a shaded cabana"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Pool"
      }
    }
  },
  "propertyoverview.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-a248-7446-b9af-538b8a627a2a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse lounge with a coffee bar, dining table and seating"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse lounge"
      }
    }
  },
  "propertyoverview.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-6b90-726e-a68d-84c6fc415472.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor pickleball and tennis court surrounded by fencing and trees"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Pickleball court"
      }
    }
  },
  "propertyoverview.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-e0ba-728e-9164-32167f8042ca.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor lounge with sofas, ambient lighting and a brick accent wall"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor lounge"
      }
    }
  },
  "reviewthemes.chip_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Helpful leasing team"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "answered all of our questions"
      }
    }
  },
  "reviewthemes.chip_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Beautiful homes"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "The houses are beautiful and welcoming"
      }
    }
  },
  "reviewthemes.chip_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "No-pressure tours"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "allowed me to take my time touring"
      }
    }
  },
  "reviewthemes.chip_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Great neighborhood"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "i love this neighborhood already"
      }
    }
  },
  "reviewthemes.chip_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Highly recommended"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "I highly recommend seeing and renting them"
      }
    }
  },
  "tourhero.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-bfff-701d-aeb6-b5c5682e34a5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Row of colorful townhomes with attached garages at Crescent Valley by Quinn Residences"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
